import React from 'react'
import PropTypes from 'prop-types'

import TableSplitButton from '~/components/TableSplitButton'
import useDeleteConfirm from '~/components/TableSplitButton/useDeleteConfirm'

function BulkActionButton ({ onAdjustmentReasonsDelete, loading }) {
  const { handleClick } = useDeleteConfirm()

  const options = [
    {
      label: 'Delete',
      'data-cy': 'deleteMenu',
      onMenuClick: () => handleClick(onAdjustmentReasonsDelete)
    },
  ]

  return (
    <TableSplitButton
      options={options}
      name="adjustmentReason"
      loading={loading}
    />
  )
}

BulkActionButton.propTypes = {
  onAdjustmentReasonsDelete: PropTypes.func.isRequired,
  loading: PropTypes.bool
}

export default BulkActionButton
